<div class="mct-grid neo-retention-grid mct-grid-lt-md mct-cols-1-lt-md" *ngIf="!isLoading"   gdGap="1rem">
  <p-chart #addDropChart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
  <div class="mct-flex mct-col mct-justify-center mct-items-start mct-gap-2rem"   >
    <div class="mct-flex mct-col mct-gap-4"  >
      <div class="mct-flex mct-row mct-gap-8"  >
        <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': colors[0] }"></div>
        <div class="f-wb">{{ 'dashboard.retention.adds' | translate | titlecase}}</div>
      </div>
      <div>{{'common.total' | translate | ucfirst }}&nbsp;{{ totalAdds }}</div>
    </div>
    <div class="mct-flex mct-col mct-gap-4"   style="padding-bottom: 16px; border-bottom: solid 1px #aaa;">
      <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-8"   >
        <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': colors[1] }"></div>
        <div class="f-wb">{{ 'dashboard.retention.drops' | translate | titlecase}}</div>
      </div>
      <div>{{'common.total' | translate | ucfirst }}&nbsp;{{ totalDrops }}</div>
    </div>
    <div class="mct-flex mct-col mct-gap-4"  >
      <div class="f-wb">{{ 'dashboard.retention.total-change' | translate | titlecase}}</div>
      <div>{{totalAdds - totalDrops}}</div>
    </div>
  </div>
</div>